export default __webpack_public_path__ + "static/media/newsletter.e471251f.webp";